import { Button, Card, Col, Form, FormControl, InputGroup, Row } from "react-bootstrap"
import { BsEye, BsPlusCircleFill, BsQuestionSquare, BsUnion } from "react-icons/bs"
import { FaCalendarAlt, FaSearch } from "react-icons/fa"
import { RiArrowLeftSLine, RiArrowRightSLine, RiFolderInfoLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import SimpleTable from "../../components/SimpleTable";
import ReactPaginate from 'react-paginate';
import { useContext, useEffect, useState } from "react";
import { authContext } from "../../context/AuthContext";
import Get from '../../api/Get'
import { PACIENTE_LIST, PACIENTE_UNIFICAR } from "../../api/Routes";
import LoadingList from "../../loader/LoadingList";
import { withTranslation } from "react-i18next";
import useCompanyType from "../../hook/useCompanyType";
import ComponentModalErrorSever from "../../components/ComponentModalErrorSever";
import Post from "../../api/Post";
import { toast } from "react-toastify";

function ListPatient({t, url}){
    const [items, setItems] = useState([])
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(20)
    const [order, setOrder] = useState('name')
    const [pageCount, setPageCount] = useState(0)
    const {auth} = useContext(authContext)
    const [loading, setLoading] = useState(true)
    const [valueSearch, setValueSearch] = useState('')
    const [search, setSearch] = useState("%20") 
    const companyType = useCompanyType()  
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false) 
    const [isSubmit, setIsSubmit] = useState(false)
    const [reload, setReload] = useState(true)
    
    useEffect(()=>{
        setLoading(true)
        const url = `${PACIENTE_LIST}/${page}/${count}/${order}/${search}`
        Get({url: url, access_token: auth.data.access_token})
        .then(response=>{
            //console.log(response)
            setItems(response.data.data.response.content)
            setPageCount(response.data.data.response.totalPages)
            setLoading(false)
            setReload(false)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [page, count, search, reload])

    const unificar = (id) =>{
        setIsSubmit(true)
        Post({url: `${PACIENTE_UNIFICAR}/${id}`, data: {}, access_token: auth.data.access_token, header: true})
        .then(response=>{
            if(response.data.state){
                toast.success("Acción exitosa", {autoClose: 2000})
                setReload(true)
            }else{
                toast.info(response.data?.error?.message, {autoClose: 8000})
            }
            setIsSubmit(false)
        })
        .catch(error=>{
            toast.error("No se puede ejecutar esta acción en estos momentos", {autoClose: 8000})
            setIsSubmit(false)
        })
    }
    
    const actions = (cell, row, index) => {
        return (
            <div>
                <ul className="list-inline mb-0">
                    <li className="list-inline-item"><Link to={`${url}/create?id=${row.id}`}><BsEye className='iconAction colorNaranja' /></Link></li>
                    <li className="list-inline-item"><Link to={`${url}/appointments/${row.id}`}><FaCalendarAlt className='iconAction colorVerde' /></Link></li>
                    <li className="list-inline-item"><Link to={`${url}/misrespuestas/${row.id}`}><BsQuestionSquare className='iconAction' /></Link></li>
                    <li className="list-inline-item"><Link to={`${url}/trazabilidad/${row.id}`}><RiFolderInfoLine className='iconAction colorRojo'/></Link></li>
                    {
                        (companyType === "colombia" && row.contieneDuplicado) && <li className="list-inline-item"><BsUnion title="Unificar paciente" onClick={()=>unificar(row.id)} /></li>
                    }
                </ul>          
            </div>
        );
    }
    const fillName = (cell, row) => {
        let firstName = `${row.name.toUpperCase() ?? ''}`
        let secname = `${row.middleName?.toUpperCase() ?? ''}`
        let firstAp = `${row.lastName.toUpperCase() ?? ''}`
        let secAp = `${row.seccondSurname?.toUpperCase() ?? ''}`

        return `${firstName} ${secname} ${firstAp} ${secAp}`
    }
    const fillDocumento = (cell, row) => {
        return row.identityDocumentType ? `${row.identityDocumentType?.code}: ${cell}` :cell
    }
    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, 
        {
            dataField: 'name',
            text: t('Nombre'),
            headerStyle: { width: '30%' },
            formatter: fillName,  
        },
        companyType === "colombia" ?
        {
            dataField: 'documentNumber',
            text: 'Documento de identidad',
            headerStyle: { width: '10%' },
            formatter: fillDocumento,
        } :
        {
            dataField: 'externalId',
            text: 'No. Poliza',
            headerStyle: { width: '10%' },
        },
        {
            dataField: 'phoneNumber',
            text: t('Telefono'),
            headerStyle: { width: '10%' },
        },
        {
            dataField: 'email',
            text: t('Correoelectronico'),
            headerStyle: { width: '30%' },
        },
        {
            dataField: '',
            isDummyField: true,
            text: t('acciones'),
            headerStyle: { width: '20%' },
            formatter: actions,            
        }
    ]

    const handlePageClick = (data) =>{
        setPage(data.selected)
    }   
    
    const searchPatient = e =>{
        e.preventDefault();
        if(valueSearch===""){
            setSearch("%20")            
        }else{
            setSearch(valueSearch)
        }
        setPage(0)        
    }

    return(
        <>
            {isSubmit && <LoadingList texto={"Procesando solicitud"}/>}
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">{t('pacientes')}</h2>
                </Col>
                <Col xs="12" md="4">
                    <Row className="align-items-center">
                        <Col xs="8" md="9">
                            <Form onSubmit={searchPatient}>
                                <InputGroup>
                                    <FormControl
                                        placeholder={t('buscar')}
                                        className="input-1"
                                        value={valueSearch}
                                        onChange={e=>setValueSearch(e.target.value)}
                                    />
                                    <InputGroup.Append>
                                        <Button type="submit" variant="outline-secondary" className="input-span-1"><FaSearch/></Button>
                                    </InputGroup.Append>
                                </InputGroup>
                            </Form>
                        </Col>
                        <Col xs="4" md="3" className="text-right">
                            <Link to={`${url}/create`}><BsPlusCircleFill className="add-btn"/></Link>                        
                        </Col>
                    </Row>                
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card className="shadow-1 mt-3">
                        <Card.Body>
                            {loading && <LoadingList />}
                            <SimpleTable columns={columns} items={items} className="th-text-uppercase"/>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col xs="12" md="10">
                    <ReactPaginate
                        previousLabel={<RiArrowLeftSLine />}
                        nextLabel={<RiArrowRightSLine />}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                </Col>
                <Col className="d-none d-md-block" xs="12" md="2">
                    <select className="select-pagin" onChange={e=>setCount(e.target.value)}>
                        <option value="20">20 / {t('pagina')}</option>
                        <option value="30">30 / {t('pagina')}</option>
                        <option value="50">50 / {t('pagina')}</option>
                    </select>
                </Col>
            </Row>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>        
    )
}

export default withTranslation()(ListPatient)